
export default {
  props: {
    callUsBanner: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    cleanTelUrl(url) {
      if (!url) return 'tel:'
      const qIdx = url.indexOf('?')
      return qIdx === -1 ? 'tel:' + url : 'tel:' + url.slice(0, qIdx)
    },
    handleButtonClick(url) {
      if (!url || !this.$gtm) return
      const qIdx = url.indexOf('?')
      if (qIdx === -1) return
      const params = new URLSearchParams(url.slice(qIdx + 1))
      const eventName = params.get('event')
      if (!eventName) return
      const leadType = params.get('lead_type') || ''
      const pageType = params.get('page_type') || undefined
      if (eventName === 'lead_redirect') {
        this.$gtm.sendLeadRedirectEvent(leadType, pageType)
      }
    },
  },
}
